export function isPositive(numString) {
  const num = parseInt(Number(numString), 10);
  if (isNaN(num) || num <= 0) {
    return false;
  }
  return true;
}
